export const reviews = [
  {
    name: "Lukas M.",
    username: "@lukas_berlin",
    avatarSeq: "avatar-lukas",
    rating: 5,
    text: "Das Oopbuy Spreadsheet hat mir unglaublich geholfen. Ich habe meine ersten Bestellungen komplett ohne Probleme abgewickelt. Die QC-Bilder waren extrem hilfreich und der Versand nach Berlin ging schneller als erwartet.",
  },
  {
    name: "Sophie K.",
    username: "@sophie_hamburg",
    avatarSeq: "avatar-sophie",
    rating: 5,
    text: "Endlich ein übersichtliches Spreadsheet für den deutschen Markt! Die Zoll-Informationen sind Gold wert. Ich spare mir Stunden an Recherche und habe schon über 20 Bestellungen erfolgreich durchgeführt.",
  },
  {
    name: "Maximilian R.",
    username: "@max_munich",
    avatarSeq: "avatar-max",
    rating: 4,
    text: "Top organisiert und immer aktuell. Besonders die Kategorisierung nach Marken und Produkttypen macht das Oopbuy Spreadsheet unverzichtbar für regelmäßige Käufer wie mich.",
  },
  {
    name: "Anna W.",
    username: "@anna_cgn",
    avatarSeq: "avatar-anna",
    rating: 5,
    text: "Ich war anfangs skeptisch, aber das Oopbuy Spreadsheet überzeugt auf ganzer Linie. Die Schritt-für-Schritt Anleitungen sind perfekt für Einsteiger. Habe schon meinen Freunden davon erzählt!",
  },
  {
    name: "Felix B.",
    username: "@felix_stuttgart",
    avatarSeq: "avatar-felix",
    rating: 5,
    text: "Das beste Tool für den Oopbuy-Einkauf! Die Integration aller wichtigen Informationen an einem Ort spart enorm Zeit. QC-Prozess und Versandtracking sind must-haves.",
  },
  {
    name: "Julia H.",
    username: "@julia_ddorf",
    avatarSeq: "avatar-julia",
    rating: 4,
    text: "Seit ich das Oopbuy Spreadsheet nutze, habe ich viel mehr Überblick über meine Bestellungen. Die Comparison-Tabelle hilft mir, die besten Deals zu finden. Kann es nur weiterempfehlen.",
  },
];

export const trustBadges = [
  { icon: "ri-shield-check-line", text: "Sicherer Checkout" },
  { icon: "ri-truck-line", text: "DE-Lieferung" },
  { icon: "ri-customer-service-2-line", text: "24/7 Support" },
];

export const stats = [
  { value: "1000+", label: "Produkte" },
  { value: "50+", label: "Premium-Marken" },
  { value: "98%", label: "Zufriedenheit" },
  { value: "48h", label: "Express-QC" },
];

export const seoGuides = [
  {
    id: "guide-1",
    title: "Der ultimative Oopbuy Spreadsheet Guide 2026",
    excerpt: "Alles was Sie über das Oopbuy Spreadsheet wissen müssen — von der ersten Bestellung bis zur Lieferung nach Deutschland.",
    imageSeq: "guide-ultimate",
    slug: "oopbuy-spreadsheet-guide-2026",
  },
  {
    id: "guide-2",
    title: "Zoll & Steuern beim Oopbuy Spreadsheet",
    excerpt: "Verstehen Sie die deutschen Zollbestimmungen für Ihre Oopbuy Spreadsheet Bestellungen.",
    imageSeq: "guide-customs",
    slug: "zoll-steuern-oopbuy-spreadsheet",
  },
  {
    id: "guide-3",
    title: "QC-Prozess beim Oopbuy Spreadsheet",
    excerpt: "So funktioniert die Qualitätskontrolle im Oopbuy Spreadsheet und warum sie unverzichtbar ist.",
    imageSeq: "guide-qc",
    slug: "qc-prozess-oopbuy-spreadsheet",
  },
  {
    id: "guide-4",
    title: "Oopbuy Spreadsheet für Einsteiger",
    excerpt: "Schritt-für-Schritt-Anleitung für Ihre erste Bestellung mit dem Oopbuy Spreadsheet.",
    imageSeq: "guide-einsteiger",
    slug: "oopbuy-spreadsheet-einsteiger",
  },
  {
    id: "guide-5",
    title: "Oopbuy Spreadsheet Preisvergleich",
    excerpt: "So sparen Sie bis zu 40% durch cleveren Preisvergleich im Oopbuy Spreadsheet.",
    imageSeq: "guide-preisvergleich",
    slug: "oopbuy-spreadsheet-preisvergleich",
  },
  {
    id: "guide-6",
    title: "Oopbuy Spreadsheet Sneaker Guide",
    excerpt: "Limitierte Releases und exklusive Sneaker im Oopbuy Spreadsheet entdecken.",
    imageSeq: "guide-sneaker",
    slug: "oopbuy-spreadsheet-sneaker-guide",
  },
  {
    id: "guide-7",
    title: "Versand nach Deutschland",
    excerpt: "Alle Versandoptionen im Oopbuy Spreadsheet im Vergleich — Express, Standard, Economy.",
    imageSeq: "guide-versand",
    slug: "oopbuy-spreadsheet-versand-deutschland",
  },
  {
    id: "guide-8",
    title: "Oopbuy Spreadsheet Sicherheit",
    excerpt: "QC-Check, Käuferschutz und verschlüsselte Zahlungen im Oopbuy Spreadsheet.",
    imageSeq: "guide-sicherheit",
    slug: "oopbuy-spreadsheet-sicherheit",
  },
  {
    id: "guide-9",
    title: "Luxusmarken-Guide",
    excerpt: "Designermode von Gucci, LV & Co. sicher und günstig im Oopbuy Spreadsheet.",
    imageSeq: "guide-luxus",
    slug: "oopbuy-spreadsheet-luxusmarken",
  },
  {
    id: "guide-10",
    title: "Oopbuy Spreadsheet Berlin",
    excerpt: "Lokaler Guide für Berliner Käufer mit Versandtipps und Community-Infos.",
    imageSeq: "guide-berlin",
    slug: "oopbuy-spreadsheet-berlin",
  },
  {
    id: "guide-11",
    title: "Rabatte & Coupons",
    excerpt: "Versteckte Rabatte und Sparstrategien im Oopbuy Spreadsheet entdecken.",
    imageSeq: "guide-rabatte",
    slug: "oopbuy-spreadsheet-rabatte",
  },
  {
    id: "guide-12",
    title: "Community & Austausch",
    excerpt: "Werden Sie Teil der Oopbuy Spreadsheet Community in Deutschland.",
    imageSeq: "guide-community",
    slug: "oopbuy-spreadsheet-community",
  },
];

export const buyingProcessSteps = [
  { step: "01", title: "Produkt auswählen", desc: "Stöbern Sie durch 14 Kategorien und finden Sie Ihr Wunschprodukt im Oopbuy Spreadsheet." },
  { step: "02", title: "Bestellung aufgeben", desc: "Geben Sie Ihre Bestellung direkt über das verlinkte Oopbuy Spreadsheet auf." },
  { step: "03", title: "QC-Check", desc: "Ihr Produkt wird im Warehouse geprüft — Sie erhalten hochauflösende QC-Bilder." },
  { step: "04", title: "Versand nach DE", desc: "Express-Versand direkt nach Deutschland mit vollständigem Tracking." },
];